import axios from "axios";

export const createImage = async (imageData) => {
  try {
    const response = await axios.post(
      `${process.env.SERVER_BASE_URL}/durga-puja-2025/image/create`,
      imageData
    );
    return response?.data?.image;
  } catch (error) {
    console.error("Error creating image:", error);
    if (error?.response?.status === 402) {
      return {
        error: "Payment Required!",
      };
    } else {
      return null;
    }
  }
};
